// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import Link from "next/link";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as CardZoomAnimation from "../../CardZoomAnimation.bs.js";
import $$Image from "next/future/image";
import * as JsxRuntime from "react/jsx-runtime";

function Category(props) {
  var disabled = props.disabled;
  var iconClassName = props.iconClassName;
  var selectCategory = props.selectCategory;
  var category = props.category;
  var disabled$1 = disabled !== undefined ? disabled : false;
  var isChecked = category.name === props.selectedCategory.name;
  var setCheckedStyle = function (checked) {
    return Cn.make([checked ? "border-prezzee-blue text-white" : ""]);
  };
  var setCheckedTextStyle = function (checked) {
    return Cn.make([checked ? "text-prezzee-blue" : ""]);
  };
  var getLink = function (slug) {
    if (slug !== "all") {
      return "/store/" + slug;
    } else {
      return "/store/";
    }
  };
  if (selectCategory !== undefined) {
    return JsxRuntime.jsx(CardZoomAnimation.make, {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("input", {
                              className: Cn.make([
                                    "hidden",
                                    setCheckedStyle(isChecked)
                                  ]),
                              id: category.name,
                              checked: isChecked,
                              name: category.name,
                              type: "radio",
                              value: category.name,
                              onChange: (function (param) {
                                  if (disabled$1) {
                                    return ;
                                  } else {
                                    return Curry._1(selectCategory, (function (param) {
                                                  return category;
                                                }));
                                  }
                                })
                            }),
                        JsxRuntime.jsxs("label", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx($$Image, {
                                            src: category.img,
                                            alt: category.name,
                                            width: 200,
                                            height: 200,
                                            className: Cn.make([
                                                  Belt_Option.getWithDefault(iconClassName, ""),
                                                  setCheckedStyle(isChecked)
                                                ])
                                          }),
                                      className: Cn.make([
                                            category.slug !== "nz-cards" ? "rounded-full h-10 w-10 p-2 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light" : "rounded-full h-10 w-10 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light",
                                            disabled$1 ? "bg-gray-400" : "",
                                            setCheckedStyle(isChecked)
                                          ])
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: Util.ReactStuff.s(category.name),
                                      className: Cn.make([
                                            "text-center text-sm lg:leading-18",
                                            disabled$1 ? "text-gray-500 " : "text-dark-gray",
                                            setCheckedTextStyle(isChecked)
                                          ])
                                    })
                              ],
                              className: disabled$1 ? "cursor-default" : "cursor-pointer",
                              htmlFor: category.name
                            })
                      ]
                    }, category.name)
              });
  } else {
    return JsxRuntime.jsx(CardZoomAnimation.make, {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Link, {
                            href: getLink(category.slug),
                            prefetch: false,
                            children: JsxRuntime.jsx("a", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx($$Image, {
                                                      src: category.img,
                                                      alt: category.name,
                                                      width: 200,
                                                      height: 200,
                                                      className: Cn.make([
                                                            Belt_Option.getWithDefault(iconClassName, ""),
                                                            setCheckedStyle(isChecked)
                                                          ])
                                                    }),
                                                className: Cn.make([
                                                      category.slug !== "nz-cards" ? "rounded-full h-10 w-10 p-2 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light" : "rounded-full h-10 w-10 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light",
                                                      setCheckedStyle(isChecked)
                                                    ])
                                              }),
                                          JsxRuntime.jsx("p", {
                                                children: Util.ReactStuff.s(category.name),
                                                className: Cn.make([
                                                      "text-center text-dark-gray text-sm lg:leading-18",
                                                      setCheckedTextStyle(isChecked)
                                                    ])
                                              })
                                        ]
                                      }),
                                  className: "cursor-pointer"
                                })
                          })
                    }, category.name)
              });
  }
}

var Link$1;

var Img;

var make = Category;

export {
  Link$1 as Link,
  Img ,
  make ,
}
/* Util Not a pure module */
